import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';

@Injectable()
export class RecommendationService {
  constructor (private http: HttpClient , private api: AppConfig) {

  }

  recommendations(type) {
    return this.http.get(this.api.baseUrl + '/recommendation/recommendations?type=' + type, this.api.jsonTokenHeaders);
  }

  addFavoriteRecommendation(data){
    return this.http.post(this.api.baseUrl + '/favoriteRecommendation/addFavoriteRecommendation', data, this.api.jsonTokenHeaders);
  }

  removeFavoriteRecommendation(id) {
    return this.http.get(this.api.baseUrl + '/favoriteRecommendation/removeFavoriteRecommendation?id=' + id, this.api.jsonTokenHeaders);
  }
  favoriteRecommendation() {
    return this.http.get(this.api.baseUrl + '/favoriteRecommendation/favoriteRecommendation', this.api.jsonTokenHeaders);
  }

  getRecommendationsCount() {
    return this.http.get(this.api.baseUrl + '/recommendation/recommendationCount', this.api.jsonTokenHeaders);
  }
}
